export const languages = ["en", "ru", "br", "in", "es", "id", "pk", "ph", "tr", "ua"];
